import * as React from 'react';

export function SvgComponent({
  width = 29,
  height = 28,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      {...props}
    >
      <path d="M39.380578,37.016236 C39.380578,37.016236 39.3712678,37.0171781 39.3703368,37.0077568 C35.2468358,33.8525678 21.7544502,17.8514543 31.6391216,0 C21.3764549,4.22167863 10.6380353,20.3226578 11.6621607,34.5327848 C10.1026971,29.3548455 8.25275436,22.5140491 1.44511404,23.3874024 C5.43640973,25.0398961 6.50150006,36.2107159 3.72984453,42.9507045 C2.45806709,46.0474815 0.96749923,49.111284 0.442402247,52.9278473 C-0.0193851708,55.3896295 -0.132038956,57.962583 0.163095341,60.5741637 C1.73093811,74.4554877 14.1209925,84.4213249 27.8386856,82.8338381 C41.5563788,81.2472934 51.4038093,68.710387 49.8359665,54.829063 C48.9924597,47.3598668 45.0067501,41.0306463 39.380578,37.016236"></path>
    </svg>
  );
}

export default SvgComponent;
